/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * EasySplit
 *
 */

import React, { memo, useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import {
  NAVIGATION_BAR_OPTIONS,
  EASY_SPLIT_PAYMENTS,
  EASY_SPLIT_REFUNDS,
  EASY_SPLIT_ADJUSTMENTS,
  TEST,
} from 'utils/constants';
import { getItemFromLocalStorage } from 'utils/common';
import { Conditional, Tab } from '@cashfree-intl/coherent';
import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';
import {
  EASY_SPLIT_SETTLEMENTS,
  EASY_SPLIT_STATUS,
  EMBED_MODAL,
  REQUEST_ACTIVATION_PAYLOAD,
} from './constants';
import { enableLoaderAction, requestActivationAction } from './actions';
import saga from './saga';
import reducer from './reducer';
import Vendors from '../Vendors';
import EasySplitPayments from '../EasySplitPayments';
import Adjustments from '../Adjustments';
import makeSelectEasySplit from './selectors';
import { resetTwoFactorAuthentication as resetTwoFactorAuthenticationValue } from '../Toast/actions';
import { twoFactorAuthenticationSelector } from '../Toast/selectors';
import { MerchantContext } from '../../contexts/MerchantContext';
import PitchPage from './components/PitchPage';
import EasySplitStatus from './components/EasySplitStatusPage';
import EmbedModal from './components/EmbedModal';
import Loader from '../../components/Loader';

import { basename } from '../../store';
import EasySplitSettlements from '../EasySplitSettlements';
export function EasySplit({
  isModuleFederated = false,
  easySplit,
  enableLoader,
  requestActivation,
  twoFactorAuthentication,
  resetTwoFactorAuthentication,
  ...props
}) {
  useInjectReducer({ key: 'easySplit', reducer });
  useInjectSaga({ key: 'easySplit', saga });
  const { menuSelected } = props;
  const { isLoading } = easySplit;
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { setMerchantContextData, ...merchantContextData } = useContext(
    MerchantContext,
  );

  const { easySplitStatus } = merchantContextData;
  const [openModalName, resetModalDisplay] = useState('');
  const { pathname } = location;
  const { env = '' } = Object.fromEntries(searchParams);
  const path = isModuleFederated
    ? pathname.split('/')[2]
    : pathname.split('/').pop();
  const navigationOptions = NAVIGATION_BAR_OPTIONS[menuSelected];
  // if activeNavigation is incorrect then redirect to first tab as selected
  const navObj = navigationOptions.find(option => option.key === path);
  let activeNavigation = navigationOptions[0].text;

  if (navObj) activeNavigation = navObj.text;
  useEffect(() => {
    if (isModuleFederated) {
      navigate(`./${navigationOptions[0].key}${env === 'test' ? '?env=test' : ''}`);
    } else if (!navObj && !isModuleFederated)
      navigate(
        `${basename}pg/easy-split/${navigationOptions[0].key}${
          env === 'test' ? '?env=test' : ''
        }`,
      );
  }, [navObj]);
  const handleNavigationClick = (e, data) => {
    let path;
    const { activeIndex, panes } = data;
    const navigationObj = navigationOptions.find(
      option => option.text === panes[activeIndex].menuItem,
    );
    if (isModuleFederated) {
      path = `./${navigationObj.key}${env === 'test' ? '?env=test' : ''}`;
    } else {
      path = `${basename}pg/easy-split/${navigationObj.key}${
        env === 'test' ? '?env=test' : ''
      }`;
    }
    if (navigationObj) navigate(path);
  };

  useEffect(() => {
    if (twoFactorAuthentication) {
      resetTwoFactorAuthentication(false);
    }
  }, [twoFactorAuthentication]);
  const closeModal = () => {
    resetModalDisplay('');
  };
  const onRequestActivation = () => {
    enableLoader();
    requestActivation({
      data: REQUEST_ACTIVATION_PAYLOAD,
      cb: response => {
        const updatedData = { easySplitEnabled: false, easySplitStatus: '' };
        updatedData.easySplitStatus = response.status;
        if (response && response.status) {
          if (
            response.status.trim().toUpperCase() === EASY_SPLIT_STATUS.ACTIVE
          ) {
            updatedData.easySplitEnabled = true;
          }
        }
        setMerchantContextData({ ...merchantContextData, ...updatedData });
      },
    });
  };
  const onTryTest = () => {
    Analytics.track(EVENTS.EASY_SPLIT.TRY_TEST_ENV);
    enableLoader();
    requestActivation({
      isTryTest: true,
      data: REQUEST_ACTIVATION_PAYLOAD,
      cb: () => {
        // eslint-disable-next-line pathname is already declared here
        const { origin, pathname, hash } = window.location; // eslint-disable-line no-use-before-define
        const testEnvURL = `${origin}${pathname}?env=${TEST}${hash}`;
        window.open(testEnvURL, '_self');
      },
    });
  };
  const playVideo = () => resetModalDisplay(EMBED_MODAL);
  const panes = [
    {
      key: navigationOptions[0]?.key,
      menuItem: !isModuleFederated ? navigationOptions[0]?.text : null,
      render: () => <Vendors {...props} />,
    },
    {
      key: navigationOptions[1]?.key,
      menuItem: !isModuleFederated ? navigationOptions[1]?.text : null,
      render: () => (
        <EasySplitPayments {...props} menuSelected={EASY_SPLIT_PAYMENTS} />
      ),
    },
    {
      key: navigationOptions[2]?.key,
      menuItem: !isModuleFederated ? navigationOptions[2]?.text : null,
      render: () => (
        <Adjustments {...props} menuSelected={EASY_SPLIT_REFUNDS} />
      ),
    },
    {
      key: navigationOptions[3]?.key,
      menuItem: !isModuleFederated ? navigationOptions[3]?.text : null,
      render: () => (
        <EasySplitSettlements
          {...props}
          menuSelected={EASY_SPLIT_SETTLEMENTS}
          activeNavigation={
            activeNavigation === 'Settlements' ? 'Scheduled' : activeNavigation
          }
        />
      ),
    },
    {
      key: navigationOptions[4]?.key,
      menuItem: !isModuleFederated ? navigationOptions[4]?.text : null,
      render: () => (
        <Adjustments {...props} menuSelected={EASY_SPLIT_ADJUSTMENTS} />
      ),
    },
  ];
  const matchedParams = pathname.split('/').slice(-1)[0];
  const subParams = pathname.split('/').slice(-2)[0];

  let activePageIndex = panes.findIndex(ele => ele.key === subParams);
  if (activePageIndex === -1) {
    activePageIndex = panes.findIndex(ele => ele.key === matchedParams);
  }
  activePageIndex = activePageIndex < 0 ? 0 : activePageIndex;

  useEffect(() => {
    renderView();
  }, [pathname]);

  const renderView = () => {
    const checkParams = pathname.split('/').pop();
    switch (checkParams) {
      case 'vendors':
        return <Vendors {...props} />;
      case 'transactions':
        return (
          <EasySplitPayments {...props} menuSelected={EASY_SPLIT_PAYMENTS} />
        );
      case 'refunds':
        return <Adjustments {...props} menuSelected={EASY_SPLIT_REFUNDS} />;
      case 'adjustments':
        return <Adjustments {...props} menuSelected={EASY_SPLIT_ADJUSTMENTS} />;
      case 'settlements':
        return (
          <EasySplitSettlements
            {...props}
            menuSelected={EASY_SPLIT_SETTLEMENTS}
            activeNavigation={
              activeNavigation === 'Settlements'
                ? 'Scheduled'
                : activeNavigation
            }
          />
        );
      default:
        return null;
    }
  };
  return (
    <div className="easy-split">
      <Loader active={isLoading} />
      <Conditional
        if={
          !easySplitStatus || easySplitStatus === EASY_SPLIT_STATUS.NOT_ACTIVE
        }
      >
        <PitchPage
          requestActivation={onRequestActivation}
          onTryTest={onTryTest}
          playVideo={playVideo}
        />
      </Conditional>
      <Conditional
        if={[EASY_SPLIT_STATUS.REQUESTED, EASY_SPLIT_STATUS.HOLD].includes(
          easySplitStatus,
        )}
      >
        <EasySplitStatus
          status={easySplitStatus}
          email={getItemFromLocalStorage('email')}
          onTryTest={onTryTest}
          playVideo={playVideo}
        />
      </Conditional>
      <Conditional if={easySplitStatus === EASY_SPLIT_STATUS.ACTIVE}>
        <div
          className={`${activePageIndex !== 3 ? 'tab-menu' : ''} ${
            isModuleFederated ? 'tab-menu-secondary' : ''
          }`}
        >
          {isModuleFederated && (
            <Tab
              activeIndex={activePageIndex}
              menu={{
                secondary: true,
                pointing: !isModuleFederated,
              }}
              panes={panes}
              onTabChange={handleNavigationClick}
            />
          )}
          {!isModuleFederated && renderView()}
        </div>
      </Conditional>
      <Conditional if={openModalName === EMBED_MODAL}>
        <EmbedModal closeModal={closeModal} />
      </Conditional>
    </div>
  );
}
EasySplit.propTypes = {
  isModuleFederated: PropTypes.bool,
  menuSelected: PropTypes.any.isRequired,
  easySplit: PropTypes.object.isRequired,
  enableLoader: PropTypes.func.isRequired,
  requestActivation: PropTypes.func.isRequired,
  twoFactorAuthentication: PropTypes.bool.isRequired,
  resetTwoFactorAuthentication: PropTypes.func.isRequired,
};
const mapStateToProps = createStructuredSelector({
  easySplit: makeSelectEasySplit(),
  twoFactorAuthentication: twoFactorAuthenticationSelector(),
});
export function mapDispatchToProps(dispatch) {
  return {
    enableLoader: () => dispatch(enableLoaderAction()),
    requestActivation: data => dispatch(requestActivationAction(data)),
    resetTwoFactorAuthentication: data =>
      dispatch(resetTwoFactorAuthenticationValue(data)),
  };
}
const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);
export default compose(
  withConnect,
  memo,
)(EasySplit);
